<template>
  <vue-slider
    v-model="sliderValue"
    :lazy="true"
    :min="min"
    :max="max"
    :dot-size="12"
    :height="3"
    :interval="2"
    :process-style="{'background': 'black'}"
    :bg-style="{'backgroundColor': '#e6e9f0'}"
    :slider-style="{'backgroundColor': 'black', 'boxShadow': 'unset'}"
    tooltip="none"
    :width="'168px'"
  />
</template>   

<script>
import VueSlider from 'vue-slider-component';

export default {
  components: {
    VueSlider
  },
  props: ['min', 'max', 'value', 'onChange'],
  data () {
    return {
      sliderValue: this.value
    };
  },
  watch: {
    sliderValue: function (size) {
      this.onChange(size);
    }
  }
};
</script>
